import { useContext } from 'react'
import AchievementsAuthContext from './AchievementsAuthContext'

const useAchievementsAuth = () => {
  const auth = useContext(AchievementsAuthContext)
  if (!auth) return {}

  return auth
}

export default useAchievementsAuth
